import gql from 'graphql-tag';

export const FRAGMENT_IMAGE_STYLE = gql`
  fragment ImageStyle on ImageStyle {
    id
    name
    referenceImagesList {
      index
      url
    }
  }
`;
